<template>
  <div class="card mb-3">
    <div class="card-header text-white bg-secondary">
      Shipping Details
      <div class="header-button float-right">
        <button type="button" class="btn btn-warning btn-sm" @click="edit">
          {{ editButtonTxt }}
        </button>
        <button type="button" class="btn btn-info btn-sm" @click="showDetails = !showDetails">
          More info
        </button>
      </div>
    </div>

    <div class="row" v-if="editMode">
      <div class="col-12">
        <form @submit.prevent="updateShipping" style="padding:15px;" :class="{ 'edit-highlight': editHighlight }">
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label for="shipping_method">Shipping Method</label>
                <input :class="{
                  'is-invalid': $v.shipping_method.$invalid && submit,
                  'is-valid': !$v.shipping_method.$invalid && submit
                }" type="text" v-model="shipping_method" class="form-control" id="shipping_method"
                  aria-describedby="shipping_method_help" placeholder="Shipping Method" />
                <div class="invalid-feedback">
                  Please provide a shipping method
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="telephone">Telephone</label>
                <input :class="{
                  'is-invalid': $v.telephone.$invalid && submit,
                  'is-valid': !$v.telephone.$invalid && submit
                }" type="text" v-model="telephone" class="form-control" id="telephone"
                  aria-describedby="shipping_method_help" placeholder="Telephone" />
                <div class="invalid-feedback" v-if="!$v.telephone.required">
                  Please provide a telephone
                </div>
                <div class="invalid-feedback" v-if="!$v.telephone.numeric">
                  Only digits are allowed
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="postcode">Postcode</label>
                <input :class="{
                  'is-invalid': $v.postcode.$invalid && submit,
                  'is-valid': !$v.postcode.$invalid && submit
                }" type="text" v-model="postcode" class="form-control" id="postcode"
                  aria-describedby="shipping_method_help" placeholder="Post code" />
                <div class="invalid-feedback" v-if="!$v.postcode.required">
                  Please provide a postcode
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="shipping_address_1">Address Line 1</label>
            <input :class="{
              'is-invalid': $v.shipping_address_1.$invalid && submit,
              'is-valid': !$v.shipping_address_1.$invalid && submit
            }" type="text" v-model="shipping_address_1" class="form-control" id="shipping_address_1"
              aria-describedby="shipping_method_help" placeholder="Address line 2" />
            <div class="invalid-feedback" v-if="!$v.shipping_address_1.required">
              Please provide a Address line 1
            </div>
            <div class="invalid-feedback" v-if="!$v.shipping_address_1.maxLength">
              Max allowed characters (35)
            </div>
          </div>

          <div class="form-group">
            <label for="shipping_address_2">Address Line 2</label>
            <input :class="{
              'is-invalid': $v.shipping_address_2.$invalid && submit,
              'is-valid': !$v.shipping_address_2.$invalid && submit
            }" type="text" v-model="shipping_address_2" class="form-control" id="shipping_address_2"
              aria-describedby="shipping_method_help" placeholder="Address line 2" />
            <div class="invalid-feedback" v-if="!$v.shipping_address_2.maxLength">
              Max allowed characters (35)
            </div>
          </div>
          <button type="submit" class="btn btn-success">Submit</button>
        </form>
      </div>
    </div>

    <table class="table table-striped" v-if="!editMode">
      <tbody>
        <tr>
          <td>Method</td>
          <td>{{ shipping_method }}</td>
        </tr>
        <tr>
          <td>Telephone</td>
          <td>{{ telephone }}</td>
        </tr>
      </tbody>
    </table>
    <table class="table table-striped" v-if="showDetails">
      <tbody>
        <tr>
          <td>Name</td>
          <td>
            {{ order.shipping_firstname + " " + order.shipping_lastname }}
          </td>
          <td>Company</td>
          <td>{{ order.shipping_company }}</td>
        </tr>
        <tr>
          <td>Address Line 1</td>
          <td colspan="3">{{ order.shipping_address_1 }}</td>
        </tr>
        <tr>
          <td>Address Line 2</td>
          <td colspan="3">{{ order.shipping_address_2 }}</td>
        </tr>
        <tr>
          <td>City</td>
          <td>{{ order.shipping_city }}</td>
          <td>County</td>
          <td>{{ order.shipping_county }}</td>
        </tr>
        <tr>
          <td>Country</td>
          <td>{{ order.shipping_country }}</td>
          <td>Postcode</td>
          <td>{{ order.shipping_postcode }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { required, numeric, maxLength } from "vuelidate/lib/validators";
export default {
  name: "shipping-details",
  props: ["order"],
  data() {
    return {
      showDetails: false,
      editMode: false,
      editButtonTxt: "Edit",
      submit: false,
      shipping_method: "",
      telephone: "",
      postcode: "",
      shipping_address_1: "",
      shipping_address_2: "",
      editHighlight: false
    };
  },
  mounted() {
    this.shipping_method = this.order.shipping_method;
    this.telephone = this.order.telephone;
    this.postcode = this.order.shipping_postcode;
    this.shipping_address_1 = this.order.shipping_address_1;
    this.shipping_address_2 = this.order.shipping_address_2;
  },
  validations: {
    shipping_method: {
      required
    },
    telephone: {
      required,
      numeric
    },
    postcode: {
      required
    },
    shipping_address_1: {
      required,
      maxLength: maxLength(35)
    },
    shipping_address_2: {
      maxLength: maxLength(35)
    }
  },
  methods: {
    edit() {
      this.editMode = !this.editMode;
      this.editButtonTxt = this.editMode ? "Cancel" : "Edit";
      this.highlightEdit();
    },
    highlightEdit() {
      this.editHighlight = true;
      setTimeout(
        function () {
          this.editHighlight = false;
        }.bind(this),
        500
      );
    },
    updateShipping() {
      this.submit = true;
      if (!this.$v.$invalid) {
        //show loader
        let loader = this.$loading.show();
        let formData = {
          shipping_method: this.shipping_method,
          telephone: this.telephone,
          shipping_postcode: this.postcode,
          shipping_address_1: this.shipping_address_1,
          shipping_address_2: this.shipping_address_2
        };

        this.$http
          .post(this.APIURL + this.BRAND + "/update-order", {
            orderID: this.order.order_id,
            data: formData
          })
          .then(
            () => {
              this.$parent.order.shipping_method = this.shipping_method;
              this.$parent.order.telephone = this.telephone;
              this.$parent.order.shipping_postcode = this.shipping_postcode;
              this.$parent.order.shipping_address_1 = this.shipping_address_1;
              this.$parent.order.shipping_address_2 = this.shipping_address_2;
              this.editMode = false;
              this.editButtonTxt = "Edit";
              this.submit = false;
              loader.hide();
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }
};
</script>
